import { Field } from 'module/api/field/types';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { SingleUserFieldFilter } from 'module/types/filter-field/filter/single-user';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';
import { getFieldValue } from './get-field-value';

export const single_user = (filter: SingleUserFieldFilter): FilterFunction => {
  const value = getFieldValue<number>(filter.field as any as Field);

  switch (filter.type) {
    case SelectFilterOperationType.IsEmpty:
      return (record) => value(record) == null;
    case SelectFilterOperationType.IsNotEmpty:
      return (record) => value(record) != null;
    case SelectFilterOperationType.Is:
      return (record) => value(record) === filter.value;
    case SelectFilterOperationType.IsNot:
      return (record) => value(record) !== filter.value;
    case SelectFilterOperationType.IsOneOf:
      return (record) => {
        const selected = value(record) as number;

        return filter.value!.some((v) => v === selected);
      };
    case SelectFilterOperationType.IsNoneOf:
      return (record) => {
        const selected = value(record) as number;

        return filter.value!.every((v) => v !== selected);
      };
    default:
      return () => true;
  }
};
